"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const UserSearchIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "30",
  height: "29",
  viewBox: "0 0 30 29",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.932 6.652c-.881 0-1.6.884-1.6 1.97 0 1.085.719 1.969 1.6 1.969.882 0 1.6-.884 1.6-1.97 0-1.085-.718-1.97-1.6-1.97m0 5.106c-1.513 0-2.743-1.407-2.743-3.135 0-1.73 1.23-3.136 2.743-3.136s2.744 1.407 2.744 3.136c0 1.728-1.23 3.135-2.744 3.135",
      fill: "#4DAA50",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M9.17 16.888h7.524l.152-2.155c.032-.444-.392-1.141-.967-1.346a9.11 9.11 0 00-5.897.001c-.569.204-.994.903-.963 1.345l.152 2.155zm8.076 1.139H8.62a.582.582 0 01-.588-.53l-.19-2.688c-.069-.99.727-2.13 1.737-2.49a10.3 10.3 0 016.702-.003c1.018.363 1.814 1.504 1.741 2.495l-.188 2.685a.581.581 0 01-.588.531z",
      fill: "#4DAA50",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.932 2.516c-5.698.001-10.335 4.5-10.337 10.03.002 5.524 4.638 10.019 10.335 10.019 5.702 0 10.34-4.496 10.34-10.023-.002-5.528-4.64-10.026-10.338-10.026m-.002 22.565C5.803 25.081.003 19.457 0 12.545.003 5.63 5.803.001 12.932 0c7.128 0 12.93 5.626 12.933 12.542 0 6.914-5.803 12.54-12.935 12.54",
      fill: "#FFF",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M28.541 29a1.24 1.24 0 01-.879-.364l-6.92-6.92A1.242 1.242 0 1122.5 19.96l6.92 6.92A1.242 1.242 0 0128.54 29",
      fill: "#FFF",
      className: "svg-fill-secondary"
    })]
  })]
});

UserSearchIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(UserSearchIcon);

exports.default = _default;